import styled from 'styled-components';
import { Box } from '../../layout/Box';

export const Wrapper = styled(Box).withConfig({ displayName: 'Wrapper' }).attrs({
    borderRadius: 2,
    width: '100%',
    px: 2,
    mb: 1,
    backgroundColor: 'var(--control-secondary-background)',
})``;
